import axios from 'axios';

// Define the base URL for the API
const API_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';

/**
 * Authenticate user and get token
 * @param {string} email - User email
 * @param {string} password - User password
 * @returns {Promise} - Returns a promise with auth data
 */
export const login = async (username, password) => {
  try {
    // Prepare form data
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    console.log('LOGIN REQUEST:', {
      url: `${API_URL}/core/login/`,
      data: params.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        accept: 'application/json'
      }
    });

    const response = await axios.post(`${API_URL}/core/login/`, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        accept: 'application/json'
      }
    });

    // Store auth token in localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem(
        'user',
        JSON.stringify({
          user_id: response.data.user_id,
          username: response.data.username,
          user_type: response.data.user_type
        })
      );
    }

    return response.data;
  } catch (error) {
    console.error('LOGIN ERROR:', error.response ? error.response.data : error);
    throw error.response ? error.response.data : new Error('Authentication service unavailable');
  }
};

/**
 * Get current logged in user info
 * @returns {Object} - User data from localStorage
 */
export const getCurrentUser = () => {
  const userStr = localStorage.getItem('user');
  if (userStr) return JSON.parse(userStr);
  return null;
};

/**
 * Logout user by removing tokens from storage
 */
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
};

/**
 * Check if user is authenticated by verifying token existence
 * @returns {boolean} - True if authenticated
 */
export const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

/**
 * Get auth token
 * @returns {string|null} - Auth token or null
 */
export const getToken = () => {
  return localStorage.getItem('token');
};
